import React, { Component } from 'react';
import { Text, DefaultButton } from 'office-ui-fabric-react/lib';
import firebase from 'firebase/app';
import Header from '../../components/Header';
import SideBar from '../../components/SideBar';
import Stack from '../../components/Stack';
import Content from '../../components/Content';
import TeamsList from '../../components/TeamsList';
import CommandHeader from '../../components/CommandHeader';
import TeamForm from '../../components/TeamForm';
import PlayersList, { computeNewConfig } from '../../components/PlayersList';
import { profileOnly } from '../../utils/enhacers';
import { profilePropType } from '../../utils/proptypes';
import DownloadAll from '../../components/DownloadAll';
import config from '../../config.json';
import { traerCambiosConfig } from '../../utils/equipos';

class Teams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      team: null,
      showModalTeam: false,
      bloquearCambios: false,
      limitarCambios: false,
    };
  }

  async componentDidMount() {
    await this.loadCambiosConfigFromDB();
  }

  loadCambiosConfigFromDB = async () => {
    const data = (await traerCambiosConfig()) || {
      limitar_cambios: true,
      bloquear_cambios: false,
    };
    this.setState({
      limitarCambios: !!data.limitar_cambios,
      bloquearCambios: !!data.bloquear_cambios,
    });
  };

  toggleBloquearCambios = async () => {
    const data = (await traerCambiosConfig()) || {
      limitar_cambios: true,
      bloquear_cambios: false,
    };

    const nuevaConfig = computeNewConfig(data);

    const db = firebase.database();
    await db.ref('limit_changes').set(nuevaConfig);

    this.setState({
      limitarCambios: nuevaConfig.limitar_cambios,
      bloquearCambios: nuevaConfig.bloquear_cambios,
    });

    alert(
      nuevaConfig.bloquear_cambios
        ? 'Cambios bloqueados correctamente.'
        : 'Cambios habilitados correctamente.',
    );
  };

  onTeamSelected = (team) => {
    this.setState({ team });
  };

  agregarEquipo = () => {
    this.setState({ showModalTeam: true });
  };

  hideAgregarEquipo = () => {
    this.setState({ showModalTeam: false });
  };

  renderSelectedContent = () => {
    const { team, bloquearCambios, limitarCambios } = this.state;
    return (
      <PlayersList
        team={team}
        key={team.tid}
        bloquearCambios={bloquearCambios}
        limitarCambios={limitarCambios}
      />
    );
  };

  renderAddTeam = () => {
    const { profile } = this.props;
    const { bloquearCambios } = this.state;
    if (!(profile.isAdmin || profile.isSuperAdmin)) {
      return null;
    }
    return (
      <CommandHeader title="Acciones Principales">
        <div className="commandHeaderButtons">
          <DefaultButton onClick={this.agregarEquipo}>
            Agrega un Equipo
          </DefaultButton>
          {profile.isSuperAdmin && (
            <DefaultButton onClick={this.toggleBloquearCambios}>
              {bloquearCambios ? 'Habilitar cambios' : 'Bloquear cambios'}
            </DefaultButton>
          )}
        </div>
        <DownloadAll />
      </CommandHeader>
    );
  };

  renderModalTeam = () => {
    const { showModalTeam } = this.state;
    return (
      <TeamForm
        showModal={showModalTeam}
        onHideModal={this.hideAgregarEquipo}
      />
    );
  };

  render() {
    const { team } = this.state;
    return (
      <>
        <Header />
        <Stack className="fullSize">
          <SideBar>
            <SideBar.Section title="Torneo">
              <Text>{config.NOMBRE_TORNEO}</Text>
            </SideBar.Section>
            <SideBar.Section title="Equipos">
              <TeamsList onTeamSelected={this.onTeamSelected} />
            </SideBar.Section>
          </SideBar>
          <Content>
            {team ? this.renderSelectedContent() : this.renderAddTeam()}
          </Content>
        </Stack>
        {this.renderModalTeam()}
      </>
    );
  }
}

Teams.propTypes = {
  profile: profilePropType.isRequired,
};

export default profileOnly(Teams);
